export enum CertificatesListView {
  SCOPE = "scope",
  TRANSACTION = "transaction",
}

export const CERTIFICATE_CATEGORIES_VIEW_COLUMNS: {
  [key in CertificatesListView]: Record<string, boolean>
} = {
  scope: {
    score: false,
    scope: true,
    type_attributes: false,
    purchaseOrder: false,
  },
  transaction: {
    score: false,
    scope: true,
    categorie: false,
    type_attributes: true,
    purchaseOrder: true,
    company: false,
    attributes: false,
  },
} as const
